import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { useAnalyticsState } from 'analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';
import { analytics } from 'app/utils/segment';
export const InstrumentPanelTitle = ({ panel, }) => {
    const { dashboard } = useAnalyticsState();
    const handleHelperClick = () => {
        analytics.analyticsHelperClicked({
            panel: panel.title,
            dashboard: dashboard.title,
        });
    };
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: panel.title })), _jsx(FlexBox, Object.assign({ role: "button", "data-analytics-panel-helper": true, "data-elevio-allow-propagation": true, onClick: handleHelperClick }, { children: _jsx(Icon, { name: "info" }) }))] })));
};
